// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallsFragment-module__font-s-10___eQxXz {
  font-size: 10px !important;
}

.ScheduledCallsFragment-module__font-s-12___ts8TR {
  font-size: 12px !important;
}

.ScheduledCallsFragment-module__font-s-13___gxUU0 {
  font-size: 13px !important;
}

.ScheduledCallsFragment-module__font-s-14___Rg0YF {
  font-size: 14px !important;
}

.ScheduledCallsFragment-module__font-s-15___aYuzv {
  font-size: 15px !important;
}

.ScheduledCallsFragment-module__font-s-16____MPjv {
  font-size: 16px !important;
}

.ScheduledCallsFragment-module__font-s-18___PtvcL {
  font-size: 18px !important;
}

.ScheduledCallsFragment-module__font-s-20___WR46F {
  font-size: 20px !important;
}

.ScheduledCallsFragment-module__font-s-22___XAe10 {
  font-size: 22px !important;
}

.ScheduledCallsFragment-module__font-s-28___ppKNC {
  font-size: 28px !important;
}

.ScheduledCallsFragment-module__font-w-400___I8XVt {
  font-weight: 400 !important;
}

.ScheduledCallsFragment-module__font-w-500___wRWda {
  font-weight: 500 !important;
}

.ScheduledCallsFragment-module__font-w-600___Li5hT {
  font-weight: 600 !important;
}

.ScheduledCallsFragment-module__font-w-700___RfZFp {
  font-weight: 700 !important;
}

.ScheduledCallsFragment-module__p-5___ACNTZ {
  padding: 5px !important;
}

.ScheduledCallsFragment-module__p-12___N8rVF {
  padding: 12px !important;
}

.ScheduledCallsFragment-module__p-16___lOA5S {
  padding: 16px !important;
}

.ScheduledCallsFragment-module__p-30___aLN1d {
  padding: 30px !important;
}

.ScheduledCallsFragment-module__p-b-0___xpNYE {
  padding-bottom: 0 !important;
}

.ScheduledCallsFragment-module__p-b-5___KdlyM {
  padding-bottom: 5px !important;
}

.ScheduledCallsFragment-module__p-b-10___ZMv8C {
  padding-bottom: 10px !important;
}

.ScheduledCallsFragment-module__p-b-12___twvlc {
  padding-bottom: 12px !important;
}

.ScheduledCallsFragment-module__p-b-16___tCldH {
  padding-bottom: 16px !important;
}

.ScheduledCallsFragment-module__p-b-18___ZV5jx {
  padding-bottom: 18px !important;
}

.ScheduledCallsFragment-module__p-b-20___TfVzA {
  padding-bottom: 20px !important;
}

.ScheduledCallsFragment-module__p-b-25___dw6jR {
  padding-bottom: 25px !important;
}

.ScheduledCallsFragment-module__p-b-30___cYM3O {
  padding-bottom: 30px !important;
}

.ScheduledCallsFragment-module__p-b-50___VonEQ {
  padding-bottom: 50px !important;
}

.ScheduledCallsFragment-module__p-t-0___WSz6N {
  padding-top: 0 !important;
}

.ScheduledCallsFragment-module__p-t-12___LXrhQ {
  padding-top: 12px !important;
}

.ScheduledCallsFragment-module__p-t-16___jzbiN {
  padding-top: 16px !important;
}

.ScheduledCallsFragment-module__p-t-18___YbdAb {
  padding-top: 18px !important;
}

.ScheduledCallsFragment-module__p-t-20___IpAKe {
  padding-top: 20px !important;
}

.ScheduledCallsFragment-module__p-t-30___PSpt3 {
  padding-top: 30px !important;
}

.ScheduledCallsFragment-module__p-t-40___J0MDP {
  padding-top: 40px !important;
}

.ScheduledCallsFragment-module__p-t-50___kRIuu {
  padding-top: 50px !important;
}

.ScheduledCallsFragment-module__p-l-20___ipplD {
  padding-left: 20px !important;
}

.ScheduledCallsFragment-module__p-l-30___LBNqh {
  padding-left: 30px !important;
}

.ScheduledCallsFragment-module__p-l-40___Aa41q {
  padding-left: 40px !important;
}

.ScheduledCallsFragment-module__p-r-16___N1B9e {
  padding-right: 16px !important;
}

.ScheduledCallsFragment-module__p-r-20___V4zlk {
  padding-right: 20px !important;
}

.ScheduledCallsFragment-module__p-r-30___ihgQ0 {
  padding-right: 30px !important;
}

.ScheduledCallsFragment-module__p-r-50___lq50g {
  padding-right: 50px !important;
}

.ScheduledCallsFragment-module__p-r-60___kgq48 {
  padding-right: 60px !important;
}

.ScheduledCallsFragment-module__m-b-1___eDbxj {
  margin-bottom: 1px !important;
}

.ScheduledCallsFragment-module__m-b-2___eixKI {
  margin-bottom: 2px !important;
}

.ScheduledCallsFragment-module__m-b-6___uABN5 {
  margin-bottom: 6px !important;
}

.ScheduledCallsFragment-module__m-b-8___c3R5V {
  margin-bottom: 8px !important;
}

.ScheduledCallsFragment-module__m-b-10___uk5CZ {
  margin-bottom: 10px !important;
}

.ScheduledCallsFragment-module__m-b-14___OOSUk {
  margin-bottom: 14px !important;
}

.ScheduledCallsFragment-module__m-b-16___Wtpmz {
  margin-bottom: 16px !important;
}

.ScheduledCallsFragment-module__m-b-20___cD7wi {
  margin-bottom: 20px !important;
}

.ScheduledCallsFragment-module__m-b-22___y20eJ {
  margin-bottom: 22px !important;
}

.ScheduledCallsFragment-module__m-b-24___u0YKh {
  margin-bottom: 24px !important;
}

.ScheduledCallsFragment-module__m-b-30___g5DNA {
  margin-bottom: 30px !important;
}

.ScheduledCallsFragment-module__m-b-32___IS7WZ {
  margin-bottom: 32px !important;
}

.ScheduledCallsFragment-module__m-b-40___JS5w9 {
  margin-bottom: 40px !important;
}

.ScheduledCallsFragment-module__m-t-2___WtJHI {
  margin-top: 2px !important;
}

.ScheduledCallsFragment-module__m-t-3___F3NaQ {
  margin-top: 3px !important;
}

.ScheduledCallsFragment-module__m-t-4___v5hJs {
  margin-top: 4px !important;
}

.ScheduledCallsFragment-module__m-t-5___HoYAw {
  margin-top: 5px !important;
}

.ScheduledCallsFragment-module__m-t-8___TaJj6 {
  margin-top: 8px !important;
}

.ScheduledCallsFragment-module__m-t-10___dociF {
  margin-top: 10px !important;
}

.ScheduledCallsFragment-module__m-t-15___Itfic {
  margin-top: 15px !important;
}

.ScheduledCallsFragment-module__m-t-16___mD0c6 {
  margin-top: 16px !important;
}

.ScheduledCallsFragment-module__m-t-20____c_Z7 {
  margin-top: 20px !important;
}

.ScheduledCallsFragment-module__m-t-22___bT9CX {
  margin-top: 22px !important;
}

.ScheduledCallsFragment-module__m-t-30___TJ8nt {
  margin-top: 30px !important;
}

.ScheduledCallsFragment-module__m-t-32___nSH0k {
  margin-top: 32px !important;
}

.ScheduledCallsFragment-module__m-l-auto___OGDlo {
  margin-left: auto !important;
}

.ScheduledCallsFragment-module__m-l-4___sj8vC {
  margin-left: 4px !important;
}

.ScheduledCallsFragment-module__m-l-5___oFjrC {
  margin-left: 5px !important;
}

.ScheduledCallsFragment-module__m-l-6___mmhi4 {
  margin-left: 6px !important;
}

.ScheduledCallsFragment-module__m-l-8___ZqR6u {
  margin-left: 8px !important;
}

.ScheduledCallsFragment-module__m-l-10___lPlJi {
  margin-left: 10px !important;
}

.ScheduledCallsFragment-module__m-l-16___l0fW7 {
  margin-left: 16px !important;
}

.ScheduledCallsFragment-module__m-l-20___LIC5J {
  margin-left: 20px !important;
}

.ScheduledCallsFragment-module__m-l-24___KGxFf {
  margin-left: 24px !important;
}

.ScheduledCallsFragment-module__m-l-30___bxde5 {
  margin-left: 30px !important;
}

.ScheduledCallsFragment-module__m-l-35___wJBFJ {
  margin-left: 35px !important;
}

.ScheduledCallsFragment-module__m-l-40___A5m_R {
  margin-left: 40px !important;
}

.ScheduledCallsFragment-module__m-r-8___faed2 {
  margin-right: 8px !important;
}

.ScheduledCallsFragment-module__m-r-10___zCy5b {
  margin-right: 10px !important;
}

.ScheduledCallsFragment-module__m-r-16___nqztb {
  margin-right: 16px !important;
}

.ScheduledCallsFragment-module__m-r-20___Jt0Pq {
  margin-right: 20px !important;
}

.ScheduledCallsFragment-module__m-r-24___wfF1v {
  margin-right: 24px !important;
}

.ScheduledCallsFragment-module__m-r-30___BsYdy {
  margin-right: 30px !important;
}

.ScheduledCallsFragment-module__m-r-40___bSpor {
  margin-right: 40px !important;
}

.ScheduledCallsFragment-module__border-r-3___HZPBw {
  border-radius: 3px !important;
}

.ScheduledCallsFragment-module__border-r-4___Phiph {
  border-radius: 4px !important;
}

.ScheduledCallsFragment-module__border-r-6___PzUaN {
  border-radius: 6px !important;
}

.ScheduledCallsFragment-module__border-r-10___nrRcA {
  border-radius: 10px !important;
}

.ScheduledCallsFragment-module__border-r-12___dQwK2 {
  border-radius: 12px !important;
}

.ScheduledCallsFragment-module__border-r-16___PRXva {
  border-radius: 16px !important;
}

.ScheduledCallsFragment-module__border-r-50___SvFzm {
  border-radius: 50% !important;
}

.ScheduledCallsFragment-module__primary-border___uy9Yj {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsFragment-module__primary-border-b___v9EyQ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsFragment-module__primary-border-t___mz7Hk {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsFragment-module__primary-border-l___Au524 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsFragment-module__primary-border-r___DVc8o {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsFragment-module__secondary-border___Zavfw {
  border: 1px solid #637768;
}

.ScheduledCallsFragment-module__secondary-border-b___zYVwk {
  border-bottom: 1px solid #637768;
}

.ScheduledCallsFragment-module__secondary-border-t___x6B0z {
  border-top: 1px solid #637768;
}

.ScheduledCallsFragment-module__secondary-border-l___WHeew {
  border-left: 1px solid #637768;
}

.ScheduledCallsFragment-module__secondary-border-r___Wqd3I {
  border-right: 1px solid #637768;
}

.ScheduledCallsFragment-module__gap-0___GU0Uz {
  gap: 0 !important;
}

.ScheduledCallsFragment-module__gap-2___qy7Ki {
  gap: 2px !important;
}

.ScheduledCallsFragment-module__gap-4___QBcTf {
  gap: 4px !important;
}

.ScheduledCallsFragment-module__gap-5___cHp3v {
  gap: 5px !important;
}

.ScheduledCallsFragment-module__gap-6___swkh_ {
  gap: 6px !important;
}

.ScheduledCallsFragment-module__gap-8___t44jR {
  gap: 8px !important;
}

.ScheduledCallsFragment-module__gap-10___nHmnI {
  gap: 10px !important;
}

.ScheduledCallsFragment-module__gap-12___Dd6pr {
  gap: 12px !important;
}

.ScheduledCallsFragment-module__gap-14___wv3kj {
  gap: 14px !important;
}

.ScheduledCallsFragment-module__gap-16___MRQ7x {
  gap: 16px !important;
}

.ScheduledCallsFragment-module__gap-18___VKtHu {
  gap: 18px !important;
}

.ScheduledCallsFragment-module__gap-20___C7zl8 {
  gap: 20px !important;
}

.ScheduledCallsFragment-module__gap-24___Nkcq_ {
  gap: 24px !important;
}

.ScheduledCallsFragment-module__gap-26___JK28i {
  gap: 26px !important;
}

.ScheduledCallsFragment-module__gap-30___rSUk0 {
  gap: 30px !important;
}

.ScheduledCallsFragment-module__gap-32___Xh4rm {
  gap: 32px !important;
}

.ScheduledCallsFragment-module__gap-40___d0I7c {
  gap: 40px !important;
}

.ScheduledCallsFragment-module__gap-50___ZCPz9 {
  gap: 50px !important;
}

.ScheduledCallsFragment-module__flex-1___FMB4O {
  flex: 1;
}

.ScheduledCallsFragment-module__flex-none___LjpXF {
  flex: none !important;
}

.ScheduledCallsFragment-module__flex-column___IOoBv {
  display: flex;
  flex-direction: column !important;
}

.ScheduledCallsFragment-module__flex-row___dfMTc {
  display: flex;
  flex-direction: row !important;
}

.ScheduledCallsFragment-module__vertically-centered___FD1WG {
  display: flex;
  align-items: center !important;
}

.ScheduledCallsFragment-module__horizontally-centered____khyl {
  display: flex;
  justify-content: center !important;
}

.ScheduledCallsFragment-module__horizontally-end___tfNqI {
  display: flex;
  justify-content: end !important;
}

.ScheduledCallsFragment-module__vertically-start___JC92K {
  display: flex;
  align-items: start !important;
}

.ScheduledCallsFragment-module__space-between___gRVe5 {
  display: flex;
  justify-content: space-between !important;
}

.ScheduledCallsFragment-module__flex-wrap___VMTyv {
  flex-wrap: wrap !important;
}

.ScheduledCallsFragment-module__height-100___NXo07 {
  height: 100%;
}

.ScheduledCallsFragment-module__width-50___cpKJR {
  width: 50% !important;
}

.ScheduledCallsFragment-module__width-100___JtOb5 {
  width: 100%;
}

.ScheduledCallsFragment-module__cursor-pointer___w5x1C {
  cursor: pointer;
}

.ScheduledCallsFragment-module__cursor-not-allowed___YRxxQ {
  cursor: not-allowed !important;
}

.ScheduledCallsFragment-module__absolute-centered___pwX3x {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ScheduledCallsFragment-module__absolute___dCbOw {
  position: absolute;
}

.ScheduledCallsFragment-module__relative___y6T_l {
  position: relative;
}

.ScheduledCallsFragment-module__fixed___EloXt {
  position: fixed;
}

.ScheduledCallsFragment-module__visible___VI09x {
  opacity: 1;
}

.ScheduledCallsFragment-module__invisible___RRydV {
  opacity: 0;
}

.ScheduledCallsFragment-module__col-90____H9rY {
  width: 90% !important;
}

.ScheduledCallsFragment-module__col-auto___P5VFB {
  width: auto !important;
}

.ScheduledCallsFragment-module__medical-tabs___Nv5fI {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ScheduledCallsFragment-module__medical-table-new___i0Xlg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsFragment-module__medical-table-new___i0Xlg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsFragment-module__medical-table-new___i0Xlg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsFragment-module__medical-table-new___i0Xlg::-webkit-scrollbar-track {
  display: none;
}
.ScheduledCallsFragment-module__medical-table-new___i0Xlg.ScheduledCallsFragment-module__no-pagination___vHeer {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsFragment-module__medical-table-new___i0Xlg.ScheduledCallsFragment-module__no-pagination___vHeer:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsFragment-module__medical-table-new___i0Xlg.ScheduledCallsFragment-module__no-pagination___vHeer::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsFragment-module__medical-table-new___i0Xlg.ScheduledCallsFragment-module__no-pagination___vHeer::-webkit-scrollbar-track {
  display: none;
}

.ScheduledCallsFragment-module__medical-table-empty___npUSR {
  padding: 14px 40px !important;
}

.ScheduledCallsFragment-module__icon-btn___HiX10 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ScheduledCallsFragment-module__search-icon___gOO9e {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ScheduledCallsFragment-module__disable-select___jAXDE {
  user-select: none;
}

.ScheduledCallsFragment-module__break-word___MNbIv {
  word-break: break-word;
}

.ScheduledCallsFragment-module__popup-clear-btn___d7hAQ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ScheduledCallsFragment-module__scroll-m-b-20___PjpH5 {
  scroll-margin-bottom: 20px;
}

.ScheduledCallsFragment-module__container___DUWuP {
  height: 100%;
  margin-top: 8px;
}
.ScheduledCallsFragment-module__container___DUWuP .ScheduledCallsFragment-module__button___LGwdf > img {
  width: 20px;
  height: 20px;
}
.ScheduledCallsFragment-module__container___DUWuP .ScheduledCallsFragment-module__tabs___KhPKy {
  padding: 0;
  margin: 0 40px -6px 40px;
}
.ScheduledCallsFragment-module__container___DUWuP .ScheduledCallsFragment-module__warningBanner___kGDWH {
  background-color: rgba(241, 191, 114, 0.5);
  color: black;
  height: 39px;
}
.ScheduledCallsFragment-module__container___DUWuP .ScheduledCallsFragment-module__actionButton___RtvR9 {
  height: 38px;
  margin: -8px 0 8px 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/ScheduledCallsFragment/ScheduledCallsFragment.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,eAAA;AA8pBF;AA3pBI;EACE,WAAA;EACA,YAAA;AA6pBN;AAzpBE;EACE,UAAA;EACA,wBAAA;AA2pBJ;AAxpBE;EACE,0CAAA;EACA,YAAA;EACA,YAAA;AA0pBJ;AAvpBE;EACE,YAAA;EACA,oBAAA;AAypBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  height: 100%;\n  margin-top: 8px;\n\n  .button {\n    & > img {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .tabs {\n    padding: 0;\n    margin: 0 40px -6px 40px;\n  }\n\n  .warningBanner {\n    background-color: rgba(241, 191, 114, 0.5);\n    color: black;\n    height: 39px;\n  }\n\n  .actionButton {\n    height: 38px;\n    margin: -8px 0 8px 0;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ScheduledCallsFragment-module__font-s-10___eQxXz`,
	"fontS12": `ScheduledCallsFragment-module__font-s-12___ts8TR`,
	"fontS13": `ScheduledCallsFragment-module__font-s-13___gxUU0`,
	"fontS14": `ScheduledCallsFragment-module__font-s-14___Rg0YF`,
	"fontS15": `ScheduledCallsFragment-module__font-s-15___aYuzv`,
	"fontS16": `ScheduledCallsFragment-module__font-s-16____MPjv`,
	"fontS18": `ScheduledCallsFragment-module__font-s-18___PtvcL`,
	"fontS20": `ScheduledCallsFragment-module__font-s-20___WR46F`,
	"fontS22": `ScheduledCallsFragment-module__font-s-22___XAe10`,
	"fontS28": `ScheduledCallsFragment-module__font-s-28___ppKNC`,
	"fontW400": `ScheduledCallsFragment-module__font-w-400___I8XVt`,
	"fontW500": `ScheduledCallsFragment-module__font-w-500___wRWda`,
	"fontW600": `ScheduledCallsFragment-module__font-w-600___Li5hT`,
	"fontW700": `ScheduledCallsFragment-module__font-w-700___RfZFp`,
	"p5": `ScheduledCallsFragment-module__p-5___ACNTZ`,
	"p12": `ScheduledCallsFragment-module__p-12___N8rVF`,
	"p16": `ScheduledCallsFragment-module__p-16___lOA5S`,
	"p30": `ScheduledCallsFragment-module__p-30___aLN1d`,
	"pB0": `ScheduledCallsFragment-module__p-b-0___xpNYE`,
	"pB5": `ScheduledCallsFragment-module__p-b-5___KdlyM`,
	"pB10": `ScheduledCallsFragment-module__p-b-10___ZMv8C`,
	"pB12": `ScheduledCallsFragment-module__p-b-12___twvlc`,
	"pB16": `ScheduledCallsFragment-module__p-b-16___tCldH`,
	"pB18": `ScheduledCallsFragment-module__p-b-18___ZV5jx`,
	"pB20": `ScheduledCallsFragment-module__p-b-20___TfVzA`,
	"pB25": `ScheduledCallsFragment-module__p-b-25___dw6jR`,
	"pB30": `ScheduledCallsFragment-module__p-b-30___cYM3O`,
	"pB50": `ScheduledCallsFragment-module__p-b-50___VonEQ`,
	"pT0": `ScheduledCallsFragment-module__p-t-0___WSz6N`,
	"pT12": `ScheduledCallsFragment-module__p-t-12___LXrhQ`,
	"pT16": `ScheduledCallsFragment-module__p-t-16___jzbiN`,
	"pT18": `ScheduledCallsFragment-module__p-t-18___YbdAb`,
	"pT20": `ScheduledCallsFragment-module__p-t-20___IpAKe`,
	"pT30": `ScheduledCallsFragment-module__p-t-30___PSpt3`,
	"pT40": `ScheduledCallsFragment-module__p-t-40___J0MDP`,
	"pT50": `ScheduledCallsFragment-module__p-t-50___kRIuu`,
	"pL20": `ScheduledCallsFragment-module__p-l-20___ipplD`,
	"pL30": `ScheduledCallsFragment-module__p-l-30___LBNqh`,
	"pL40": `ScheduledCallsFragment-module__p-l-40___Aa41q`,
	"pR16": `ScheduledCallsFragment-module__p-r-16___N1B9e`,
	"pR20": `ScheduledCallsFragment-module__p-r-20___V4zlk`,
	"pR30": `ScheduledCallsFragment-module__p-r-30___ihgQ0`,
	"pR50": `ScheduledCallsFragment-module__p-r-50___lq50g`,
	"pR60": `ScheduledCallsFragment-module__p-r-60___kgq48`,
	"mB1": `ScheduledCallsFragment-module__m-b-1___eDbxj`,
	"mB2": `ScheduledCallsFragment-module__m-b-2___eixKI`,
	"mB6": `ScheduledCallsFragment-module__m-b-6___uABN5`,
	"mB8": `ScheduledCallsFragment-module__m-b-8___c3R5V`,
	"mB10": `ScheduledCallsFragment-module__m-b-10___uk5CZ`,
	"mB14": `ScheduledCallsFragment-module__m-b-14___OOSUk`,
	"mB16": `ScheduledCallsFragment-module__m-b-16___Wtpmz`,
	"mB20": `ScheduledCallsFragment-module__m-b-20___cD7wi`,
	"mB22": `ScheduledCallsFragment-module__m-b-22___y20eJ`,
	"mB24": `ScheduledCallsFragment-module__m-b-24___u0YKh`,
	"mB30": `ScheduledCallsFragment-module__m-b-30___g5DNA`,
	"mB32": `ScheduledCallsFragment-module__m-b-32___IS7WZ`,
	"mB40": `ScheduledCallsFragment-module__m-b-40___JS5w9`,
	"mT2": `ScheduledCallsFragment-module__m-t-2___WtJHI`,
	"mT3": `ScheduledCallsFragment-module__m-t-3___F3NaQ`,
	"mT4": `ScheduledCallsFragment-module__m-t-4___v5hJs`,
	"mT5": `ScheduledCallsFragment-module__m-t-5___HoYAw`,
	"mT8": `ScheduledCallsFragment-module__m-t-8___TaJj6`,
	"mT10": `ScheduledCallsFragment-module__m-t-10___dociF`,
	"mT15": `ScheduledCallsFragment-module__m-t-15___Itfic`,
	"mT16": `ScheduledCallsFragment-module__m-t-16___mD0c6`,
	"mT20": `ScheduledCallsFragment-module__m-t-20____c_Z7`,
	"mT22": `ScheduledCallsFragment-module__m-t-22___bT9CX`,
	"mT30": `ScheduledCallsFragment-module__m-t-30___TJ8nt`,
	"mT32": `ScheduledCallsFragment-module__m-t-32___nSH0k`,
	"mLAuto": `ScheduledCallsFragment-module__m-l-auto___OGDlo`,
	"mL4": `ScheduledCallsFragment-module__m-l-4___sj8vC`,
	"mL5": `ScheduledCallsFragment-module__m-l-5___oFjrC`,
	"mL6": `ScheduledCallsFragment-module__m-l-6___mmhi4`,
	"mL8": `ScheduledCallsFragment-module__m-l-8___ZqR6u`,
	"mL10": `ScheduledCallsFragment-module__m-l-10___lPlJi`,
	"mL16": `ScheduledCallsFragment-module__m-l-16___l0fW7`,
	"mL20": `ScheduledCallsFragment-module__m-l-20___LIC5J`,
	"mL24": `ScheduledCallsFragment-module__m-l-24___KGxFf`,
	"mL30": `ScheduledCallsFragment-module__m-l-30___bxde5`,
	"mL35": `ScheduledCallsFragment-module__m-l-35___wJBFJ`,
	"mL40": `ScheduledCallsFragment-module__m-l-40___A5m_R`,
	"mR8": `ScheduledCallsFragment-module__m-r-8___faed2`,
	"mR10": `ScheduledCallsFragment-module__m-r-10___zCy5b`,
	"mR16": `ScheduledCallsFragment-module__m-r-16___nqztb`,
	"mR20": `ScheduledCallsFragment-module__m-r-20___Jt0Pq`,
	"mR24": `ScheduledCallsFragment-module__m-r-24___wfF1v`,
	"mR30": `ScheduledCallsFragment-module__m-r-30___BsYdy`,
	"mR40": `ScheduledCallsFragment-module__m-r-40___bSpor`,
	"borderR3": `ScheduledCallsFragment-module__border-r-3___HZPBw`,
	"borderR4": `ScheduledCallsFragment-module__border-r-4___Phiph`,
	"borderR6": `ScheduledCallsFragment-module__border-r-6___PzUaN`,
	"borderR10": `ScheduledCallsFragment-module__border-r-10___nrRcA`,
	"borderR12": `ScheduledCallsFragment-module__border-r-12___dQwK2`,
	"borderR16": `ScheduledCallsFragment-module__border-r-16___PRXva`,
	"borderR50": `ScheduledCallsFragment-module__border-r-50___SvFzm`,
	"primaryBorder": `ScheduledCallsFragment-module__primary-border___uy9Yj`,
	"primaryBorderB": `ScheduledCallsFragment-module__primary-border-b___v9EyQ`,
	"primaryBorderT": `ScheduledCallsFragment-module__primary-border-t___mz7Hk`,
	"primaryBorderL": `ScheduledCallsFragment-module__primary-border-l___Au524`,
	"primaryBorderR": `ScheduledCallsFragment-module__primary-border-r___DVc8o`,
	"secondaryBorder": `ScheduledCallsFragment-module__secondary-border___Zavfw`,
	"secondaryBorderB": `ScheduledCallsFragment-module__secondary-border-b___zYVwk`,
	"secondaryBorderT": `ScheduledCallsFragment-module__secondary-border-t___x6B0z`,
	"secondaryBorderL": `ScheduledCallsFragment-module__secondary-border-l___WHeew`,
	"secondaryBorderR": `ScheduledCallsFragment-module__secondary-border-r___Wqd3I`,
	"gap0": `ScheduledCallsFragment-module__gap-0___GU0Uz`,
	"gap2": `ScheduledCallsFragment-module__gap-2___qy7Ki`,
	"gap4": `ScheduledCallsFragment-module__gap-4___QBcTf`,
	"gap5": `ScheduledCallsFragment-module__gap-5___cHp3v`,
	"gap6": `ScheduledCallsFragment-module__gap-6___swkh_`,
	"gap8": `ScheduledCallsFragment-module__gap-8___t44jR`,
	"gap10": `ScheduledCallsFragment-module__gap-10___nHmnI`,
	"gap12": `ScheduledCallsFragment-module__gap-12___Dd6pr`,
	"gap14": `ScheduledCallsFragment-module__gap-14___wv3kj`,
	"gap16": `ScheduledCallsFragment-module__gap-16___MRQ7x`,
	"gap18": `ScheduledCallsFragment-module__gap-18___VKtHu`,
	"gap20": `ScheduledCallsFragment-module__gap-20___C7zl8`,
	"gap24": `ScheduledCallsFragment-module__gap-24___Nkcq_`,
	"gap26": `ScheduledCallsFragment-module__gap-26___JK28i`,
	"gap30": `ScheduledCallsFragment-module__gap-30___rSUk0`,
	"gap32": `ScheduledCallsFragment-module__gap-32___Xh4rm`,
	"gap40": `ScheduledCallsFragment-module__gap-40___d0I7c`,
	"gap50": `ScheduledCallsFragment-module__gap-50___ZCPz9`,
	"flex1": `ScheduledCallsFragment-module__flex-1___FMB4O`,
	"flexNone": `ScheduledCallsFragment-module__flex-none___LjpXF`,
	"flexColumn": `ScheduledCallsFragment-module__flex-column___IOoBv`,
	"flexRow": `ScheduledCallsFragment-module__flex-row___dfMTc`,
	"verticallyCentered": `ScheduledCallsFragment-module__vertically-centered___FD1WG`,
	"horizontallyCentered": `ScheduledCallsFragment-module__horizontally-centered____khyl`,
	"horizontallyEnd": `ScheduledCallsFragment-module__horizontally-end___tfNqI`,
	"verticallyStart": `ScheduledCallsFragment-module__vertically-start___JC92K`,
	"spaceBetween": `ScheduledCallsFragment-module__space-between___gRVe5`,
	"flexWrap": `ScheduledCallsFragment-module__flex-wrap___VMTyv`,
	"height100": `ScheduledCallsFragment-module__height-100___NXo07`,
	"width50": `ScheduledCallsFragment-module__width-50___cpKJR`,
	"width100": `ScheduledCallsFragment-module__width-100___JtOb5`,
	"cursorPointer": `ScheduledCallsFragment-module__cursor-pointer___w5x1C`,
	"cursorNotAllowed": `ScheduledCallsFragment-module__cursor-not-allowed___YRxxQ`,
	"absoluteCentered": `ScheduledCallsFragment-module__absolute-centered___pwX3x`,
	"absolute": `ScheduledCallsFragment-module__absolute___dCbOw`,
	"relative": `ScheduledCallsFragment-module__relative___y6T_l`,
	"fixed": `ScheduledCallsFragment-module__fixed___EloXt`,
	"visible": `ScheduledCallsFragment-module__visible___VI09x`,
	"invisible": `ScheduledCallsFragment-module__invisible___RRydV`,
	"col90": `ScheduledCallsFragment-module__col-90____H9rY`,
	"colAuto": `ScheduledCallsFragment-module__col-auto___P5VFB`,
	"medicalTabs": `ScheduledCallsFragment-module__medical-tabs___Nv5fI`,
	"medicalTableNew": `ScheduledCallsFragment-module__medical-table-new___i0Xlg`,
	"noPagination": `ScheduledCallsFragment-module__no-pagination___vHeer`,
	"medicalTableEmpty": `ScheduledCallsFragment-module__medical-table-empty___npUSR`,
	"iconBtn": `ScheduledCallsFragment-module__icon-btn___HiX10`,
	"searchIcon": `ScheduledCallsFragment-module__search-icon___gOO9e`,
	"disableSelect": `ScheduledCallsFragment-module__disable-select___jAXDE`,
	"breakWord": `ScheduledCallsFragment-module__break-word___MNbIv`,
	"popupClearBtn": `ScheduledCallsFragment-module__popup-clear-btn___d7hAQ`,
	"scrollMB20": `ScheduledCallsFragment-module__scroll-m-b-20___PjpH5`,
	"container": `ScheduledCallsFragment-module__container___DUWuP`,
	"button": `ScheduledCallsFragment-module__button___LGwdf`,
	"tabs": `ScheduledCallsFragment-module__tabs___KhPKy`,
	"warningBanner": `ScheduledCallsFragment-module__warningBanner___kGDWH`,
	"actionButton": `ScheduledCallsFragment-module__actionButton___RtvR9`
};
module.exports = ___CSS_LOADER_EXPORT___;
